<template>
  <div>
    <PageTitle title="Room Details" :backBtn="true" :showLoading="isLoading" />

    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12">
            <!-- <v-card-title>Images </v-card-title> -->
            <v-container fluid>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-row v-if="RoomImages && RoomImages.length > 0" class="mt-2">
                  <v-col
                    v-for="(image, index) in RoomImages"
                    :key="index"
                    cols="3"
                    class="d-flex justify-center"
                  >
                    <v-img
                      :src="image"
                      max-width="350"
                      max-height="350"
                      aspect-ratio="1"
                      class="rounded"
                      contain
                    />
                  </v-col>
                </v-row>

                <!-- Empty state -->
                <div v-else class="no-image-box">
                  <v-icon size="40" color="grey">mdi-image-off</v-icon>
                  <p>No images uploaded</p>
                </div>
              </v-col>

              <v-row>
                <v-col cols="3" sm="3" md="3" lg="3">
                  <h4>Reference Number</h4>
                </v-col>
                <v-col cols="3" sm="3" md="3" lg="3">
                  <v-chip label>{{ Room.reference_number }}</v-chip>
                </v-col>
                <v-col cols="3" sm="3" md="3" lg="3">
                  <h4>Name</h4>
                </v-col>
                <v-col cols="3" sm="3" md="3" lg="3">
                  <v-chip label>{{ Room.name }}</v-chip>
                </v-col>
                <v-col cols="3" sm="3" md="3" lg="3">
                  <h4>Floor</h4>
                </v-col>
                <v-col cols="3" sm="3" md="3" lg="3">
                  <v-chip label>{{ Room.floor.name }}</v-chip>
                </v-col>
                <v-col cols="3" sm="3" md="3" lg="3">
                  <h4>Phone Expression</h4>
                </v-col>
                <v-col cols="3" sm="3" md="3" lg="3">
                  <v-chip label>{{ Room.phone_expression }}</v-chip>
                </v-col>
              </v-row>
              <v-col cols="3">
                <h4>Smoking Option</h4>
              </v-col>

              <v-col cols="3">
                <v-chip
                  :color="Room.is_smoking ? 'red' : 'green'"
                  text-color="white"
                >
                  <v-icon left>
                    {{ Room.is_smoking ? "mdi-smoking" : "mdi-smoking-off" }}
                  </v-icon>
                  {{ Room.is_smoking ? "Smoking Room" : "Non-Smoking Room" }}
                </v-chip>
              </v-col>
            </v-container>
          </v-card>
        </v-col>
        <!-- <v-col cols="4" sm="4" md="4" lg="4">
          <v-card class="lighten-12" height="100%">
            <v-card-title>Details</v-card-title>
            <v-container fluid>
              <v-row>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <h4>Reference Number</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <v-chip label>{{ Room.reference_number }}</v-chip>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <h4>Name</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <v-chip label>{{ Room.name }}</v-chip>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <h4>Floor</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <v-chip label>{{ Room.floor.name }}</v-chip>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <h4>Phone Expression</h4>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <v-chip label>{{ Room.phone_expression }}</v-chip>
                </v-col>
              </v-row>
              <v-row> </v-row>
            </v-container>
          </v-card>
        </v-col> -->
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card class="lighten-12" height="100%">
            <v-container fluid>
              <v-card-title>Room Types</v-card-title>

              <div v-for="(item, index) in Room.types" :key="index">
                <v-row>
                  <v-col cols="3" sm="3" md="3" lg="3">
                    <h3>Room type name</h3>
                  </v-col>
                  <v-col cols="3" sm="3" md="3" lg="3">
                    <v-chip label
                      ><h3>{{ item.room_type.name }}</h3></v-chip
                    >
                  </v-col>
                  <v-col cols="3" sm="3" md="3" lg="3">
                    <h3>Description</h3>
                  </v-col>
                  <v-col cols="3" sm="3" md="3" lg="3">
                    <v-chip label
                      ><h3>{{ item.room_type.note }}</h3></v-chip
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" sm="3" md="3" lg="3">
                    <h3>Amount</h3>
                  </v-col>
                  <v-col cols="3" sm="3" md="3" lg="3">
                    <v-chip large color="primary">
                      <v-icon left> mdi-cash-usd </v-icon>
                      <h3>
                        {{ item.amount }}
                      </h3>
                    </v-chip>
                  </v-col>
                </v-row>
                <v-spacer></v-spacer>

                <v-row>
                  <v-col cols="6" sm="6" md="6" lg="6">
                    <v-card-text>
                      <v-card-title> Amenities </v-card-title>
                      <v-chip-group
                        active-class="deep-purple accent-4 white--text"
                        column
                        v-for="(amenitie, index) in item.room_type.amenities"
                        :key="index"
                      >
                        <v-chip class="ma-2" color="green" text-color="white">
                          <v-icon left> mdi-access-point </v-icon
                          >{{ amenitie.name }}</v-chip
                        >
                      </v-chip-group>
                    </v-card-text>
                  </v-col>
                  <!-- <v-col cols="3" sm="3" md="3" lg="3">
                  <h4>Name</h4>
                </v-col> -->
                  <v-col cols="3" sm="3" md="3" lg="3">
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <h4>Base Adult</h4>
                      <v-chip class="ma-2" color="orange" label outlined>
                        <v-icon left> mdi-human </v-icon>
                        {{ item.room_type.base_adult }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <h4>Max Adult</h4>
                      <v-chip class="ma-2" color="orange" label outlined>
                        <v-icon left> mdi-human-male-female </v-icon>
                        {{ item.room_type.max_adult }}
                      </v-chip>
                    </v-col>
                  </v-col>
                  <v-col cols="3" sm="3" md="3" lg="3">
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <h4>Base Child</h4>
                      <v-chip class="ma-2" color="orange" label outlined>
                        <v-icon left> mdi-human-child </v-icon>
                        {{ item.room_type.base_child }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <h4>Max Child</h4>
                      <v-chip class="ma-2" color="orange" label outlined>
                        <v-icon left> mdi-human-male-female </v-icon>
                        {{ item.room_type.max_child }}
                      </v-chip>
                    </v-col>
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
// import RoomProperty from "./RoomProperty.vue";
import { required, email, max } from "vee-validate/dist/rules";
import FileUpload from "@/components/base/FileUpload";
import { Room } from "../../../models/Room";
import { ProductEntity } from "../../../models/EntityModels/ProductEntity";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import { ProductBrand } from "../../../models/ProductBrand";
// import the component
import Treeselect from "@riophae/vue-treeselect";
import carousel from "vue-owl-carousel";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import axios from "@/plugins/axios";
setInteractionMode("eager");

// Mixins
// import Categories from "@/mixins/Categories";

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  // mixins: [Categories],
  components: {
    ValidationProvider,
    ValidationObserver,
    Treeselect,
    carousel,
    FileUpload,
    // RoomProperty,
  },
  data: () => ({
    roomFloors: [],
    Dishes: [],
    RoomDetails: new Room(),
    bedTypes: [],
    Room: new Room(),
    errors: [],
    messages: [],
    loaded: false,
    suppliers: [],
    selectedSuppliers: [],
  }),
  created() {
    this.GetFloors();
    this.GetRoomTypes();
    this.GetAllRoomImages();
    this.GetRoom();
  },
  methods: {
    async submit() {
      this.clickSubmit = true;
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.EditRoom();
      }
    },

    clear() {
      // this.Supplier = new Supplier();
      this.isClickedClear = false;
      this.isClickedClear = true;
      this.Product = [];
      this.selectedImages = [];
      this.$refs.unitComponent.resetUnits();
      this.$refs.fileUpload.removeItem(0);
      this.$refs.observer.reset();
    },
    EditRoom() {
      this.isLoading = true;
      let id = this.$route.params.id;
      axios
        .patch(`hms/rooms/${id}`, this.Room)
        .then(async (res) => {
          this.succeeed = true;
          if (this.selectedImages) {
            await this.UploadRoomImage(this.$route.params.id)
              .then(() => {
                this.isDisabledSubmit = false;
                this.isLoading = false;
              })
              .catch(() => {
                this.$toast.error("Room image uploading failed");
                this.isDisabledSubmit = false;
                this.isLoading = false;
              });
          }
          this.$toast.success("Room created  successfully");
          this.$router.push("/room");
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);

          // this.messages.push(err.data.title);
          this.$toast.error("Product create failed");
          this.isDisabledSubmit = false;
          this.isLoading = false;
        });
    },
    async UploadRoomImage(productId) {
      let fromData = new FormData();
      for (var i = 0; i < this.selectedImages.length; i++) {
        fromData.append("images", this.selectedImages[i]);
      }
      fromData.append("id", productId);
      console.log("SELECTED IMAGES", fromData);

      axios
        .post(`hms/rooms/${productId}/images`, fromData)
        .then((res) => {})
        .catch((err) => {});
    },
    GetFloors() {
      axios
        .get(`hms/floors`)
        .then((res) => {
          this.roomFloors = res.data.data;
        })
        .catch((err) => {});
    },
    GetAllRoomImages() {
      let id = this.$route.params.id;
      axios
        .get(`hms/rooms/${id}/images`)
        .then((res) => {
          this.RoomImages = res.data.data;
          this.loaded = true;
        })
        .catch((err) => {});
    },
    GetRoomTypes() {
      axios
        .get(`hms/room-types`)
        .then((res) => {
          this.roomTypes = res.data.data;
        })
        .catch((err) => {});
    },
    GetBedTypes() {
      axios
        .get(`hms/bed-types`)
        .then((res) => {
          this.bedTypes = res.data.data;
        })
        .catch((err) => {});
    },
    async GetRoom() {
      let id = this.$route.params.id;
      axios
        .get(`hms/rooms/${id}`)
        .then((res) => {
          this.Room = Room.toViewModel(res.data);
          this.loaded = true;
        })
        .catch((err) => {});
    },
  },

  watch: {
    searchBrand: {
      handler(val) {
        this.GetBrandByQuery(val);
      },
      deep: true,
    },
    searchCategory: {
      handler(val) {
        this.GetProductCategoriesByQuery(val);
      },
      deep: true,
    },
  },
};
</script>

<style lang="stylus" scoped>
#example-custom-transition {
  .fades {
    &-enter-active, &-leave-active, &-leave-to {
      transition: 0.3s ease-out;
      position: absolute;
      top: 0;
      left: 0;
    }

    &-enter, &-leave, &-leave-to {
      opacity: 0;
    }
  }
}
</style>
